import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'vds-content-base-downloads',
  styleUrl: 'vds-content-base-downloads.scss',
  shadow: true,
})
export class VdsContentBaseDownloads {

  render() {
    return (
      <Host>
        <div class="py-1 md:border-y-2 md:border-solid md:border-grey-lighter">
          <div class="flex flex-col flex-wrap gap-y-1 md:flex-row md:justify-start md:gap-y-0 md:gap-x-4">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }

}
